<template>
    <div class="ml-5 mr-5 mt-5" id="workerCreate">
        <v-row>
            <v-col cols="12">
                <p class="text-left mb-0">{{ $t("workers.description") }}</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="12">
                <v-stepper v-model="step" non-linear>
                    <v-stepper-header>
                        <v-stepper-step
                        :complete="step > 1"
                        step="1" color="primary"
                        >{{ $t("workers.step_1") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step
                        :complete="step > 2"
                        step="2" color="primary"
                        >{{ $t("workers.step_2") }}</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step
                        :complete="step > 3"
                        step="3" color="primary"
                        >{{ $t("workers.step_3") }}</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-items >
                        <v-stepper-content step="1" style="padding: 0 0 12px 0;">
                            <v-container>
                                <v-row>
                                    <v-col md="12" cols="12">
                                        <p class="mb-0">{{ $t("workers.description_step_1") }}</p>
                                    </v-col>
                                    <v-col md="12" cols="12">
                                        <h2 style="text-align: center;">{{ $t("workers.subtitle_step_1") }}</h2>
                                    </v-col>
                                    <v-col class="text-center">
                                        <v-row>
                                            <v-col md="6" cols="12" class="text-md-right">
                                                <v-btn 
                                                dark
                                                @click="yesCreated"
                                                color="primary"
                                                class="mt-6 mb-sm-6 mb-0 btn_bg"
                                                >{{ $t("workers.button_yes_create_account")}}</v-btn>
                                            </v-col>
                                            <v-col md="6" cols="12" class="text-md-left">
                                                <v-btn
                                                dark
                                                @click="noCreated"
                                                color="primary"
                                                class="mt-6 mb-6 btn_bg"
                                                >{{ $t("workers.button_no_create_account")}}</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                            <v-container>
                                <v-row>
                                    <v-col>
                                        <Register 
                                            @showSnackBar="(params) => $emit('showSnackBar',params)" 
                                            @showError="showError" 
                                            @showErrorOptions="showErrorOptions" 
                                            @backStep="step=1"
                                            @nextStep="goToStep3"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                            <v-container>
                                <v-row>
                                    <v-col md="6" class="text-left">
                                        <v-btn
                                            dark
                                            @click="noCreated"
                                            color="primary"
                                            class="btn_back btn_bg"
                                        >{{ $t("workers.back_button")}}</v-btn>
                                    </v-col>
                                    <v-col md="6" v-if="selected.length > 0" class="text-right">
                                        <v-btn
                                            dark
                                            @click="submit"
                                            color="primary"
                                            class="btn_back btn_bg"
                                        >{{ $t("workers.next")}}</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="12" cols="12">
                                        <p class="text-left">{{ $t("workers.content_step_3") }}</p>
                                    </v-col>
                                </v-row>
                                <v-form ref="formEmail" class="mt-sm-0 mt-4" @submit.prevent="searchByEmail">
                                    <v-row>
                                        <v-col md="3" sm="4" cols="12" class="lbl_search">
                                            <label class="lbl_search text-left">
                                                <v-icon>fa fa-search</v-icon>
                                                {{ $t("workers.find_by_email") }}
                                            </label>
                                            <v-text-field
                                                v-model="email"
                                                :rules="rules.email" dense
                                                outlined>
                                            </v-text-field>
                                        </v-col>
                                        <v-col md="3" sm="4" cols="12">
                                            <v-btn class="float-left mt-sm-6 mt-0 btn_xs_rsp" type="submit" :loading="loadingEmail">
                                                {{ $t("workers.search_by_email")}}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-form ref="formLLId" class="mt-sm-0 mt-4" @submit.prevent="searchByLLId">
                                    <v-row>
                                        <v-col md="3" sm="4" cols="12" class="lbl_search">
                                            <label class="lbl_search text-left">
                                                <v-icon>fa fa-search</v-icon>
                                                {{ $t("workers.find_by_ll_id") }}
                                            </label>
                                            <v-text-field 
                                                v-model="LLId"
                                                :rules="rules.LLId" dense
                                                outlined></v-text-field>
                                        </v-col>
                                        <v-col md="3" sm="4" cols="12">
                                            <v-btn class="float-left mt-sm-6 mt-0 btn_xs_rsp" type="submit" :loading="loadingId">
                                                {{ $t("workers.search_by_ll_id")}}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-row no-gutters class="my-4">
                                    <v-col md="12" cols="12">
                                        <p class="text-left mb-1">{{ $t("workers.search_results_table")}}</p>
                                    </v-col>
                                    <v-col md="12" cols="12" class="mb-1">
                                        <!-- Table ... -->
                                        <v-data-table
                                            :headers="headers"
                                            :items="items"
                                            @click:row="selectRow"
                                            item-key="id"
                                            class="elevation-2 ma-0 dt_rider" 
                                            dense 
                                            :footer-props="{
                                                'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                                'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                            }"
                                            :no-data-text="$t('dataTable.noDataText')"
                                            :headerProps="{
                                                'sort-by-text': $t('dataTable.sortByText')
                                            }"
                                        >
                                            <template v-slot:[`item.selected`]="{ item }">
                                                <v-simple-checkbox class="mt-0" v-model="item.selected" :ripple="false" @click="selectRow(item)"></v-simple-checkbox>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                    <v-col v-if="participantSelected" class="text-left mt-1">
                                        <!-- card selected -->
                                        <h4>{{ $t("workers.selected_worker")}}</h4>
                                        <v-card max-width="344" outlined>
                                        <v-list-item v-for="(item, index) in selected" :key="index" two-line>
                                            <v-list-item-avatar tile size="80" color="grey" class="mb-2 mt-2">
                                                <v-img height="100%" width="100%" :src="item.image" v-on:error="ImgError"></v-img>
                                            </v-list-item-avatar>
                                            <v-list-item-content v-if="item">
                                                <v-list-item-title>
                                                    {{ item.firstName }} {{ item.lastName }}
                                                    <div
                                                        style="position: absolute; right: 5px; top: 5px;"
                                                    >
                                                        <v-btn depressed color="error" @click="selectRow(item)">
                                                        <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </div>
                                                </v-list-item-title>
                                                <v-list-item-title>{{ $t("workers.table_header_ll_id")}}: {{ item.id }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
        <SGSNotificationAlert 
            v-if="dialogAlert" 
            :notificationMessage="alertMessage" 
            @cancel="dialogAlert = false" 
            :type="options.type" 
            :showBtn="options.showBtn" 
            :small="options.small"
            :xSmall="options.xSmall"
            :widthMd="options.widthMd"
        />
    </div>
</template>

<script>
import { mapState } from "vuex";
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import Register from "@/components/workers/Register.vue";

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
   mixins: [apiCalls],
   components: {
    SGSNotificationAlert, Register
   },
   data() {
       return {
        step: 1,
        buttonColor: '',
        singleSelect: true,
        items: [],
        selected: [],
        participantSelected: false,
        loadingId: false,
        LLId: '',
        email: '',
        loadingEmail: false,
        dialogAlert: false,
        alertMessage: '',
        options: {
            type: 'error', 
            showBtn: true, 
            small: false,
            xSmall: false,
            widthMd: false
        }
       };
   },
   computed: {
        headers(){
        return [
        {
            text: this.$t("common.table.select"),
            sortable: false,
            value: "selected"
            },
            {
            text: this.$t("workers.table_header_ll_id"),
            value: "id"
            },
            {
            text: this.$t("workers.table_header_first_name"),
            value: "firstName"
            },
            {
            text: this.$t("workers.table_header_last_name"),
            value: "lastName"
            }
        ]
        },
        ...mapState({
            user: state => state.session.session.userSession
        }),
        rules() {
            return {
                select: [(v) => !!v || this.$t("workers.select_required")],
                email: [
                    val => (val || "").length > 0 || this.$t("workers.email_required"),
                    val => pattern.test(val) || this.$t("common.email_invalid")
                ],
                LLId: [
                    val => val > 0 || this.$t("workers.id_number_required")
                ],
                firstName: [
                    val => (val || "").length > 0 || this.$t("workers.firstname_required")
                ],
                lastName: [
                    val => (val || "").length > 0 || this.$t("workers.lastname_required")
                ],
                relationship: [
                    val => (val || "").length > 0 || this.$t("workers.relationship_required")
                ],
                type: [
                    val => (val || "").length > 0 || this.$t("workers.type_required")
                ]
            };
        },
   },
   methods: {
        reloadstep(e) {
            this.step = e;
        },
        yesCreated() {
            this.step = 3;
        },
        noCreated() {
            switch (this.step) {
                case 2:
                    this.step = 1;
                break;
                case 1:
                    this.step = 2;
                break;
                case 3:
                    this.step = 1;
                break;
            }
        },
        showError(msg) {
            this.alertMessage = msg;
            this.dialogAlert = true;
        },
        showErrorOptions({msg,options}) {
            this.alertMessage = msg;
            for(let property in options) {
                this.options[property] = options[property]
            }
            this.dialogAlert = true;
        },
        searchByEmail(){
            if(!this.$refs.formEmail.validate()) {
                return
            }
            
            if(this.email == this.user.email) {
                this.items = [];
                this.alertMessage = this.$t("common.cannot_add_yourself");
                this.dialogAlert = true;
                return
            }
            
            this.search('email', this.email);
        },
        searchByLLId(){
        
            if(!this.$refs.formLLId.validate()) {
                return
            }
            
            if(this.LLId == this.user.id) {
                this.items = [];
                this.alertMessage = this.$t("common.cannot_add_yourself");
                this.dialogAlert = true;
                return
            }

            this.search('id', this.LLId);
        },
        selectRow(item) {
            let _item = this.selected.indexOf(item);
            let _item1 = this.items.indexOf(item);
            if (_item > -1) {
                this.selected.splice(_item, 1);
                if(_item1 > -1) this.items[_item1].selected = false;
            } else {
                this.selected.push(item);
                if(_item1 > -1) this.items[_item1].selected = true;
            }
            if(_item1 <= -1 && this.items[_item1]) this.items[_item1].selected = false;
        },
        itemsSelected(){
            if(this.selected.length > 0){
                this.participantSelected = true;
            } else {
                this.participantSelected = false;
            }
        },
        ImgError() {
            this.failed_image = false;
        },
        cleanData(){
            this.selected = [];
            this.email = null;
            this.LLId = null;
            this.participantSelected = false;
            this.items = [];
        },
        nextStep() {
            this.step++;
        },
        async search(type, value, autoSelect = false) {
            let data = { value };
            const response = await this.postApi(`/api/v1/promoter/relationShip/search/${type}`,data);
            
            if(response.success) {
                let items = [];
                this.items = response.message.filter((el) => el.id != this.user.id).map((el) => { 
                    let item = {
                        ...el, 
                        selected: autoSelect ? true : false,
                        image: (el.image != null && el.image.length > 0) ? process.env.VUE_APP_ROOT+"/"+el.image: require("@/assets/images/orgPlaceholder.jpg.png")
                    };
                    if(autoSelect) {
                        items.push(item);
                    }
                    return item;
                });
                if(autoSelect) {
                    items.forEach((item) => {
                        this.selectRow(item);
                    });
                }
            }
        },
        goToStep3() {
            let _item =  localStorage.getItem('create_worker');
            _item = _item != null ? JSON.parse(_item): null;
            
            if(_item) {
                this.search('id', _item, true);
            }
            this.nextStep();
        },
        async submit() {
            if(!(this.selected && Array.isArray(this.selected) && this.selected.length > 0)) {
                return
            }
            let data = {
                workers: this.selected.map((el) => {
                    return { relId: el.id };
                })
            };
            const response = await this.postApi('/api/v1/promoter/relationShip/create',data);
            
            if(response.success) {
                this.$emit("showSnackBar",{ snack: true, msg: this.$t("common.success"), type: "success" });
                this.$router.push({ name: 'Workers' });
            } else {
                this.alertMessage = this.$t("common.cannot_add_yourself");
                this.dialogAlert = true;
            }
        }
   },
   created() {
    this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
   },
   watch: {
       selected() {
           this.itemsSelected();
       }
   }
}
</script>